import { useState, useCallback } from 'react'
import KampaniePlacowkiService from '@/services/KampaniePlacowkiService'

export default function usePlacowkiData(kampaniaId) {
	const [data, setData] = useState([])
	const [loading, setLoading] = useState(true)
	const [loadingMore, setLoadingMore] = useState(false)
	const [error, setError] = useState(null)
	const [totalCount, setTotalCount] = useState(0)
	const [hasMore, setHasMore] = useState(false)
	const [filters, setFilters] = useState({})
	const [sortColumn, setSortColumn] = useState('_id')
	const [sortDirection, setSortDirection] = useState('desc')
	const [limit, setLimit] = useState(50)

	const loadData = useCallback(async () => {
		if (!kampaniaId) {
			setData([])
			setTotalCount(0)
			setHasMore(false)
			setLoading(false)
			setLoadingMore(false)
			return
		}

		setLoadingMore(prevLoadingMore => {
			if (!prevLoadingMore) setLoading(true)
			return prevLoadingMore
		})
		setError(null)

		const searchText = (filters.searchText || '').trim()
		const requestOptions = {
			limit,
			sortColumn,
			sortDirection,
			filters: {
				kampaniaId,
				placowkaId: filters.placowkaId || null,
				id_miasto: filters.id_miasto || null,
				id_gmina: filters.id_gmina || null,
				id_powiat: filters.id_powiat || null,
				id_wojewodztwo: filters.id_wojewodztwo || null,
				id_typ: filters.id_typ || null,
				triage:
					filters.triage !== null && filters.triage !== undefined && filters.triage !== ''
						? filters.triage
						: null,
			},
		}
		const result = searchText
			? await KampaniePlacowkiService.search(searchText, requestOptions)
			: await KampaniePlacowkiService.getFiltered(requestOptions)

		if (result.error) {
			setError(result.error)
			setData([])
			setTotalCount(0)
			setHasMore(false)
		} else {
			setData(result.data)
			setTotalCount(result.totalCount)
			setHasMore(result.hasMore)
		}

		setLoading(false)
		setLoadingMore(false)
	}, [kampaniaId, limit, sortColumn, sortDirection, filters])

	const handleLoadMore = useCallback(() => {
		if (hasMore && !loadingMore) {
			setLimit(prev => prev + 50)
			setLoadingMore(true)
		}
	}, [hasMore, loadingMore])

	const setSorting = useCallback((column, direction) => {
		setSortColumn(column)
		setSortDirection(direction)
	}, [])

	const updateFilters = useCallback(newFilters => {
		setFilters(prevFilters => ({ ...prevFilters, ...newFilters }))
		setLimit(50)
	}, [])

	const clearError = useCallback(() => {
		setError(null)
	}, [])

	return {
		data,
		loading,
		loadingMore,
		error,
		totalCount,
		hasMore,
		loadData,
		handleLoadMore,
		setSorting,
		updateFilters,
		sortColumn,
		sortDirection,
		searchQuery: filters.searchText || '',
		clearError,
	}
}
